import { Link } from '@inertiajs/react'
import logoBlue from '../../../design-system/brand/logo-blue.svg'
import logoWhite from '../../../design-system/brand/logo-white.svg'
import { useI18n } from '../i18n'

/**
 * Brand lockup — the Geo4Logistics mark (design-system/brand/logo-*.svg) plus the
 * "Geo4Logistics / Freight Forwarding" wordmark. The blue mark shows on light
 * surfaces (the nav); the white mark shows on dark surfaces (the navy footer).
 * The swap is driven by CSS (.brand .logo / .footer .brand .logo) so the same
 * component reads correctly in both contexts.
 */
export default function Brand() {
  const { t } = useI18n()
  return (
    <Link className="brand" href="/" aria-label={t('a11y.brandHome')}>
      <span className="logo">
        <img className="on-light" src={logoBlue} alt="" aria-hidden="true" />
        <img className="on-dark" src={logoWhite} alt="" aria-hidden="true" />
      </span>
      <span>
        <b>Geo4Logistics</b>
        <small>Freight Forwarding</small>
      </span>
    </Link>
  )
}
